import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

export const GTM_ID = publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

export const pageview = (url) => {
  window.dataLayer.push({
    event: "pageview",
    page: url,
  });
};

export const pushGtmEvent = (event) => {
  if (typeof window === "undefined") {
    console.log("Window is not available (SSR)");
    return;
  }

  if (!window.dataLayer) {
    console.error("dataLayer is not available");
    return;
  }
  window.dataLayer.push(event);
};
